<template>
  <div class="h-toolbarBg">
    <ejs-toolbar ref="toolBarForTask">
      <e-items>
        <e-item prefixIcon='icon hero-icon hero-icon-export' :tooltipText="$t('Common.export')" :click='buttonClick' operate='export'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-statistics' :tooltipText="$t('Alarm.statistics')" :click='buttonClick' operate='statistics'></e-item>
      </e-items>
    </ejs-toolbar>
  </div>
</template>

<script>
export default {
  name: 'ReportGnbDataMenu',
  data() {
    return {
    };
  },
  methods: {
    buttonClick(args){
      this.$parent.methodList(args.item.operate);
    }
  },
  watch: {
  }
};
</script>

<style>

</style>
